import { FormattedMessage } from 'react-intl'

interface TranslateProps {
  entityName: string
  fieldName?: string
  defaultMessage?: string
  values?: Record<string, React.ReactNode>
  children?: any
}

export const Translate = ({
  entityName,
  fieldName,
  defaultMessage,
  values,
  children,
}: TranslateProps) => {
  return (
    <FormattedMessage
      values={values}
      tagName={({ children }: any) => (
        <span
          className="translate"
          dangerouslySetInnerHTML={{ __html: children }}
        />
      )}
      id={fieldName ? `${entityName}.${fieldName}` : `${entityName}`}
      defaultMessage={
        defaultMessage ??
        (fieldName ? `${fieldName} (${entityName})` : entityName)
      }
    >
      { children }
    </FormattedMessage>
  )
}
